import {
  Button,
  Divider,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuList,
  TextField,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "../widgets/Listwidget.css";
import React, { useState, useEffect } from "react";
import { ReactComponent as DeleteSvg } from "../../../components/icon/delete.svg";
import { ReactComponent as EditSvg } from "../../../components/icon/edit.svg";
import { ReactComponent as SearchSvg } from "../../../components/icon/search.svg";
import { ReactComponent as FilterStack } from "../../../components/icon/filterstack.svg";
import { ReactComponent as ClearSvg } from "../../../components/icon/clear.svg"; // Assuming you have an "X" icon SVG
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DeletePrompt from "../../presentation/common-component/DeletePrompt";
import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import { CardHeader } from "../../../components/bootstrap/Card";
import CloseIcon from "@mui/icons-material/Close";
import FilterMenu from "../../../components/FilterMenu";
import SearchInput from "../../../components/SearchInput";
const token = localStorage.getItem("token");
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";
import ToastComponent from "../../../components/ToastComponent";

interface DataSourceDetail {
  id: number;
  name: string;
}

interface WidgetListProps {
  type: "add" | "delete";
  detail: DataSourceDetail[];
  newId: number;
}

function ListDatasource(this: any, { dataSourceList, setDataSourceList }: any) {
  // console.log(props);
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  type WIDGET = {
    createUser: string;
    createDate: string;
    updateUser: string | null;
    updateTime: string | null;
    id: number;
    name: string;
    queryId: number;
    viewTypeId: any;
    roles: any[];
    groups: any[];
  };
  const [rowDataToBeDeleted, setRowDataToBeDeleted] = React.useState<any>();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [rowHeight, setRowHeight] = useState<number>(0);
  const open = Boolean(anchorEl);
  const Buttons: (params: any) => React.JSX.Element = (
    params: any
  ): React.JSX.Element => (
    <div className="items-justify-center justify-center w-fit">
      <IconButton onClick={() => edit(params)}>
        <EditSvg />
      </IconButton>
      <> </>
      <IconButton onClick={() => deleteData(params)}>
        <DeleteSvg className="" />
      </IconButton>
    </div>
  );
  const token = localStorage.getItem("token");
  const [openPreviewDialog, setOpenPreviewDialog] = React.useState(false);
  const [openPreviewDeleteDialog, setOpenPreviewDeleteDialog] =
    React.useState(false);
  const [rows, setRows] = React.useState<any[]>([{ id: 1 }]);
  const [duplicateRows, setDuplicateRows] = React.useState<any[]>([{ id: 1 }]);
  const [columns, setColumns]: any[] = React.useState<any[]>([
    {
      field: "id",
      headerName: "ID",
      width: 100,
      filter: "agNumberColumnFilter",
      resizable: true,
      hide: true,
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "url",
      headerName: "URL",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "userName",
      headerName: "User Name",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "pwd",
      headerName: "Password",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
      valueFormatter: () => "******", // Masking the password
    },
    {
      field: "dbFamily",
      headerName: "DB Family",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "driverName",
      headerName: "Driver Name",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "driverType",
      headerName: "Driver Type",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "dbType",
      headerName: "DB Type",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 400,
      cellRenderer: Buttons,
      cellRendererParams: {
        edit: edit.bind(this),
        deleteDataSource: deleteDataSource.bind(this),
        preview: preview.bind(this),
      },
      resizable: true,
      flex: 25,
      cellClass: "other-column",
    },
  ]);
  const [dataSourceData, setDataSourceData] = React.useState<any>();
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [filterValue, setFilterValue] = useState<string>("");
  const [gridApi, setGridApi] = useState<any>(null);
  const apiCallToGetAllDataSources = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Authentication token not found");
      }

      const response = await fetch(
        `${vyu_api_url}/datasource/getAllDatasource`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        throw new Error("Invalid data format received from server");
      }
      let dataToShow = data;
      setRows(dataToShow);
      setDuplicateRows(dataToShow);
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Failed to fetch data sources";
      handleError(errorMessage);
      setRows([]);
      setDuplicateRows([]);
    }
  };
  const calculateRowHeight = () => {
    const vh = window.innerHeight / 100;
    return 6 * vh;
  };
  useEffect(() => {
    const updateRowHeight = () => setRowHeight(calculateRowHeight());
    updateRowHeight();
    window.addEventListener("resize", updateRowHeight);

    return () => window.removeEventListener("resize", updateRowHeight);
  }, []);
  React.useEffect(() => {
    apiCallToGetAllDataSources();
  }, []);
  console.log(rows);
  const deleteDatasourceApiCall = async (param: any) => {
    console.log(param);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${vyu_api_url}/datasource/deleteById?id=${param.data.id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      handleSuccess(data.message);
      if (response.status === 200) {
        apiCallToGetAllDataSources();
      }
    } catch (e) {
      handleError("Error");
      console.error("error occured ", e);
    }
  };

  function deleteData(params: any) {
    console.log("In delete Data:", params);

    setOpenPreviewDeleteDialog(true);
    setRowDataToBeDeleted(params);
  }

  function edit(params: any) {
    // console.log(params)
    let DsDetail: DataSourceDetail = {
      id: params.data.id,
      name: params.data.name,
    };
    const isPresent = dataSourceList.detail.some(
      (item: DataSourceDetail) => item.id === DsDetail.id
    );
    setDataSourceList({
      type: "add",
      detail: isPresent
        ? dataSourceList.detail
        : [...dataSourceList.detail, DsDetail],
      newId: params.data.id,
    });
  }

  function deleteDataSource() {
    deleteDatasourceApiCall(rowDataToBeDeleted);
  }
  // function deleteDataSourceOnConfirmation(
  //   data: any,
  //   confirmDelete: boolean = false
  // ) {
  //   deleteDatasourceApiCall(data);
  //   setOpenPreviewDeleteDialog(false);
  // }
  function preview(data: any) {
    console.log(data);
    setOpenPreviewDialog(true);
    setDataSourceData({
      viewType: data.data.viewTypeId.name,
      dataSourceData: data.data,
    });

    // console.log({ viewType: data.data.viewTypeId.name, dataSourceData: data.data });
  }

  const filters: any = {
    Name: "name",
    URL: "url",
    "User Name": "userName",
    "Driver Name": "driverName",
    "Driver Type": "driverType",
    "DB Type": "dbType",
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Remove a specific filter
  const handleRemoveFilter = (filterKey: string) => {
    setSelectedFilters((prev) => prev.filter((item) => item !== filterKey));
  };

  // Function to add/remove filters
  const toggleFilter = (filter: string) => {
    setSelectedFilters(
      (prevFilters) =>
        prevFilters.includes(filter)
          ? prevFilters.filter((f) => f !== filter) // Remove if already selected
          : [...prevFilters, filter] // Add if not selected
    );
  };

  // Function to apply filters to the row data
  const applyFilters = async (searchTerm: string) => {
    if (gridApi) gridApi.showLoadingOverlay();
    try {
      // Construct URL with query parameters
      const params = new URLSearchParams({
        dataSource: searchTerm,
        filter: selectedFilters.join(","), // Join filters array as a comma-separated string
      });

      const response = await fetch(
        `${vyu_api_url}/filter/query/searchDataSource?${params}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        console.error("Server error:", response.status, response.statusText);
        return;
      }
      const data = await response.json();
      const dataToShow = data?.obj?.map((item: any) => {
        return {
          ...item,
          dataSource: item.name,
          // parentQueryName: item.parentQuery?.name,
        };
      });

      // Check if the response format includes 'obj' and if 'obj' is not empty
      if (data.status === "Success" && data.obj) {
        if (data.obj.length > 0) {
          setRows(dataToShow); // Set rows with the content of 'obj' array
        } else {
          console.log("No results found.");
          setRows([]); // Set rows to an empty array if 'obj' is empty
        }
      } else {
        setRows([]); // Clear rows if the structure is unexpected
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error,
        `${vyu_api_url}/filter/query/searchDataSource`
      );
    } finally {
      if (gridApi) gridApi.hideOverlay();
    }
  };

  // Modified search filter function
  const handleSearchFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFilterValue(value);
    // // If no filters are selected and input is not empty, apply the search value across all columns
    // if (selectedFilters.length === 0 && value !== "") {
    //   const filteredRows = duplicateRows.filter((item) => {
    //     return Object.keys(item).some((key) => {
    //       const itemValue = item[key];
    //       return (
    //         typeof itemValue === "string" &&
    //         itemValue.toLowerCase().includes(value.toLowerCase())
    //       );
    //     });
    //   });
    //   setRows(filteredRows);
    //   return;
    // }
    // If input is empty, apply all selected filters
    if (!value) {
      setRows(duplicateRows);
      return;
    }
    if (value.length >= 2) {
      applyFilters(value);
    } else {
      // Option 1: Reset to original data
      setRows(duplicateRows);
      // Option 2: Do nothing (keep previous results)
      // return;
    }
  };

  const getRowStyle = (params: any) => {
    if (params.node.rowIndex % 2 !== 0) {
      return { background: "#F5F7F8", height: "10px", display: "flex" };
    } else {
      return { background: "#FCFCFC", height: "10px", display: "flex" };
    }
  };

  const handleWarning = (message: string) => {
    showWarningToast(message);
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };

  return (
    <>
      {/* <CardHeader>
        <Breadcrumb
          list={[
            { title: "DataSource", to: "" },
            { title: "List", to: "" },
          ]}
        />
      </CardHeader> */}
      <div style={{ paddingLeft: "2vh" }}>
        <DeletePrompt
          component={"DataSource"}
          dataToBeDeleted={rowDataToBeDeleted}
          open={openPreviewDeleteDialog}
          onclose={() => setOpenPreviewDeleteDialog(false)}
          confirmCallBack={deleteDataSource}
          data={dataSourceData}
        />
        <SearchInput
          filterValue={filterValue}
          onSearchChange={handleSearchFilter}
          selectedFilters={selectedFilters}
        />
        <FilterMenu
          filters={filters}
          selectedFilters={selectedFilters}
          onToggleFilter={toggleFilter}
          onRemoveFilter={handleRemoveFilter}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onOpen={handleClick}
        />
      </div>
      <div
        style={{
          width: "100%",
          fontSize: 14,
          // fontStyle: "italic",
        }}
      >
        <div className="grid-div">
          <AgGridReact
            className="ag-theme-quartz ag-theme-quartz-listWidget"
            rowData={rows}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={false}
            rowHeight={rowHeight}
            getRowStyle={getRowStyle}
            onGridReady={(params) => setGridApi(params.api)}
          />
        </div>
      </div>
      <ToastComponent />
    </>
  );
}
const styleObj = {
  backgroundColor: "#F3F1FF",
  "text-transform": "capitalize",
  // "font-style": "italic",
  border: "2px solid #998CEB",
  color: "black",
  height: "36px",
  "&:hover": {
    backgroundColor: "#F3F1FF",
  },
  // "&:active": {
  //   backgroundColor: "pink"
  // }
};

export default ListDatasource;
